import type { OnChanges, SimpleChanges } from '@angular/core'
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  inject,
  input,
  output,
} from '@angular/core'
import { FormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'

import { FormatAuthorNamePipe } from '../../../../shared/pipes/format-author-name.pipe'
import { SharedModule } from '../../../../shared/shared.module'
import type {
  ExpandedSections,
  FilterAuthor,
  FilterCategory,
  FilterMagazine,
  FilterType,
  ScrollEvent,
  SelectionEvent,
} from '../../../../types/types'
import { FilterItemComponent } from '../filter-item/filter-item.component'

@Component({
  selector: 'dhp-mobile-filter',
  templateUrl: './mobile-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    TranslatePipe,
    SharedModule,
    FilterItemComponent,
    FormatAuthorNamePipe,
  ],
})
export class MobileFilterComponent implements OnChanges {
  private readonly cdr = inject(ChangeDetectorRef)

  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() isOpen = false
  readonly magazines = input<FilterMagazine[]>([])
  readonly authors = input<FilterAuthor[]>([])
  readonly types = input<FilterType[]>([])

  readonly expandedSections = input<ExpandedSections>({
    magazines: true,
    types: false,
    authors: false,
  })

  readonly magazinesSelectedCount = input(0)
  readonly authorsSelectedCount = input(0)
  readonly typesSelectedCount = input(0)
  readonly totalArticles = input(0)
  readonly isLoadingAuthors = input(false)
  readonly authorSearchTerm = input<string>()

  readonly closeDialog = output()
  readonly toggleSection = output<keyof ExpandedSections>()
  readonly toggleSelection = output<SelectionEvent>()
  readonly clearSelection = output<FilterCategory>()
  readonly applyFilters = output()
  readonly resetFilters = output()
  readonly scrollChange = output<ScrollEvent>()
  readonly searchTermChange = output<string | undefined>()

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    // Prevent click events from propagating outside
    event.stopPropagation()
  }

  trackByMagazineId(index: number, magazine: FilterMagazine): string | number {
    return magazine.id
  }

  trackByAuthorId(index: number, author: FilterAuthor): string | number {
    return author.id
  }

  trackByTypeId(index: number, type: FilterType): string | number {
    return type.id
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      this.cdr.detectChanges()
    }
  }
}
